import axios from 'axios';

// Create axios instance
export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000', //change the url before deployment
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');       //remember to remove comment this from hamza ahmad
    if (token) {                                       //remember to remove comment this from hamza ahmad
      config.headers.Authorization = `Bearer ${token}`;   //remember to remove comment this from hamza ahmad
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// API functions
export const prescriptionAPI = {
  // Get all prescriptions
  getAll: () => api.get('/prescriptions'),
  
  // Get single prescription
  getById: (id) => api.get(`/prescriptions/${id}`),
  
  // Upload prescription
  upload: (formData) => api.post('/prescriptions/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  
  // Update prescription
  update: (id, data) => api.put(`/prescriptions/${id}`, data),
  
  // Delete prescription
  delete: (id) => api.delete(`/prescriptions/${id}`),
  
  // Download prescription
  download: (id) => api.get(`/prescriptions/${id}/download`, {
    responseType: 'blob',
  }),
};

export const icdAPI = {
  // Get ICD codes
  getAll: () => api.get('/icd-codes'),
};

export const adminAPI = {
  // Get all users (admin only)
  getAllUsers: () => api.get('/admin/users'),
};

export const profileAPI = {
  getMe: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/profile', data),
  changePassword: (data) => api.put('/auth/change-password', data),
};

export const passwordResetAPI = {
  request: (email) => api.post('/auth/password-reset/request', { email }),
  confirm: (email, code, newPassword) =>
    api.post('/auth/password-reset/confirm', { email, code, new_password: newPassword }),
};

export default api; 